import { useQuery } from "@apollo/client";
import { useBindToChannelEvent } from "components/providers/Realtime/useBindToChannelEvent";
import { GET_CURRENT_HEATS_CONFIG } from "./CurrentHeatsConfig.gql";
import { GetCurrentHeatsConfigQuery, GetCurrentHeatsConfigQueryVariables } from "./CurrentHeatsConfig.gql.types";

export const useGetCurrentHeatsConfig = (eventId: string) => {
    const eventChannel = `event:${eventId}`;

    const { data, refetch } = useQuery<GetCurrentHeatsConfigQuery, GetCurrentHeatsConfigQueryVariables>(GET_CURRENT_HEATS_CONFIG, {
        variables: { id: eventId },
        fetchPolicy: "cache-and-network"
    });

    useBindToChannelEvent({ channelName: eventChannel, skip: !data?.event }, "current-heats-changed", () => refetch());

    return { data };
};
